import React, { useEffect, useState } from "react";
import { useFetch } from "../../hooks/useFetch";
import { API_PAYMENT_CHECKOUT } from "../../constants/api";
import Modal from "../common/Modal/Modal";
import StripeCheckout from "../StripeCheckout/StripeCheckout";
import Button from "../common/Button/Button";
import "./PaymentModal.css";

interface PaymentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  firstName: string;
  lastName: string;
}

const PaymentModal: React.FC<PaymentModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
  firstName,
  lastName,
}) => {
  const { request } = useFetch();
  const [clientSecret, setClientSecret] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // 调用后端API创建Checkout Session
  const createCheckoutSession = async () => {
    try {
      const {
        data: { clientSecret },
      } = await request<{ clientSecret: string }>(API_PAYMENT_CHECKOUT, {
        method: "POST",
        body: {
          firstName,
          lastName,
        },
      });
      setClientSecret(clientSecret);
    } catch (error) {
      setError("Unable to initialize payment. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setLoading(true);
      setError(null);
      createCheckoutSession();
    }
  }, [isOpen]);

  const handlePaymentSuccess = () => {
    // 支付成功后的处理
    onSuccess();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnClickOutside={false}
      title={`Unlock 99 Creative Designs for "${firstName} ${lastName}"`}
    >
      {loading ? (
        <div className="payment-loading">
          <div className="loading-spinner"></div>
          <p>Preparing payment...</p>
        </div>
      ) : error ? (
        <div className="payment-error">
          <p>{error}</p>
          <Button variant="primary" onClick={onClose}>
            Close
          </Button>
        </div>
      ) : (
        <StripeCheckout
          clientSecret={clientSecret}
          onSuccess={handlePaymentSuccess}
          onCancel={onClose}
        />
      )}
    </Modal>
  );
};

export default PaymentModal;
